import React from 'react';
import { observer } from 'mobx-react';

import { NodeHotKey } from 'libs/editor/plugins/helpers/nodeHotKey';
import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';

const ListItemNode = observer(({ attributes, children }) => (
  <li {...attributes}>{children}</li>
));

export function ListItem() {
  return {
    plugins: [
      NodeHotKey({ key: '-', type: 'list_item' }),
      RenderNode('list_item', props => <ListItemNode {...props} />),
    ],
  };
}
